import Request from '@/requests/Request'

//import fileDownload from 'js-file-download';

export default {
  root(projetoId) {
    let url = "/storage/{projetoId}/root"
      .replace(new RegExp("{projetoId}", "g"), projetoId)
    return Request.get(url)
  },

  list(payload) {
    let url = "/storage/{projetoId}/list?path={path}"
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      .replace(new RegExp("{path}", "g"), payload.path);
    return Request.get(url)
  },

  mkdir(payload) {
    let url = "/storage/{projetoId}/mkdir?path={path}&nome={nome}"
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      .replace(new RegExp("{path}", "g"), payload.path)
      .replace(new RegExp("{nome}", "g"), payload.newFolderName);

    return Request.post(url)
  },

  rename(payload) {
    let url = "/storage/{projetoId}/rename/{itemStorageId}?pathPai={pathPai}&novoNome={novoNome}"
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      .replace(new RegExp("{itemStorageId}", "g"), payload.itemStorageId)
      .replace(new RegExp("{pathPai}", "g"), payload.pathPai)
      .replace(new RegExp("{novoNome}", "g"), payload.novoNome);

    return Request.post(url)
  },

  download(projetoId, itemId) {
    let url = "/storage/{projetoId}/download/{itemId}"
      .replace(new RegExp("{projetoId}", "g"), projetoId)
      .replace(new RegExp("{itemId}", "g"), itemId);

    Request.get(url, { responseType: 'arraybuffer' }).then(function (response) {
      let blob = new Blob([response.data], { type: response.headers.ContentType })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.headers.nomearquivo
      link.click()
    })
  },

  delete(payload) {
    let url = "/storage/{projetoId}/delete/{itemStorageId}"
      .replace(new RegExp("{projetoId}", "g"), payload.projetoId)
      .replace(new RegExp("{itemStorageId}", "g"), payload.arquivoId)
    return Request.delete(url)
  },

  request(config) {
    return Request.request(config);
  }
}
